import * as React from "react"
import { cx } from "emotion"
import { Flex } from "@indeed/ifl-components"
import { StyleProps } from "@indeed/ifl-components/src/utils/styled"

export const SingleColumnPage: React.FC<{ id?: string; sx?: StyleProps["sx"]; className?: string; children?: React.ReactNode }> = (
    props
) => {
    const { id, className, children, sx } = props

    return (
        <Flex id={id} sx={{ flexDirection: "column", inlineSize: "100%", ...sx }} className={cx(className)}>
            {children}
        </Flex>
    )
}
